import styled from "@emotion/styled";

import { BaseImage } from "scmp-app/components/common/base-image";

export const Container = styled.div``;

export const StyledBaseImage = styled(BaseImage)`
  max-inline-size: 240px;
  margin-inline-end: 12px;
`;

export const Caption = styled.figcaption`
  color: #000000;
  font-size: 10px;
  line-height: 11.7px;
`;
